export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100 rounded-3xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              随时随地 · 甜蜜观影
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              糖心影视网站完美适配手机、平板和电脑浏览器，无需下载任何APP，打开网页即可畅享高清影视。
              支持iOS、Android、Windows等多平台，您的观影进度自动同步。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-smartphone-line mr-2 align-middle"></i>
                手机端体验
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto px-8 py-3 text-sm font-medium text-foreground-700 border border-background-300/60 rounded-lg hover:border-primary-300 hover:text-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-computer-line mr-2 align-middle"></i>
                电脑端体验
              </a>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-[200px] h-[340px] rounded-2xl overflow-hidden bg-background-200 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20showing%20a%20movie%20streaming%20interface%20with%20film%20posters%2C%20warm%20coral%20and%20golden%20accents%2C%20clean%20modern%20UI%20design%2C%20cinematic%20dark%20mode%20theme%2C%20elegant%20layout%2C%20no%20real%20text&width=400&height=680&seq=app-mockup-001&orientation=portrait"
                alt="糖心影视手机端观影界面"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}